import React from "react"
import { Timeline, Tabs } from 'antd';
import useFetch from "../../hooks/useFetch";

const BigEvent = ({ d }) => {

  const items = d ? d.map((item) => {
    const { content, url } = item
    return {
      children: <a style={{ fontSize: 14 }} href={url} target="_blank">{content}</a>
    }
  }) : []

  return (
    <>
      <h2 className="font-bold text-[44px] my-14">发展历程</h2>
      <Timeline
        mode="alternate"
        items={items}
      />
    </>
  )
}

const Customer = ({ coustmer }) => {

  return (
    <div id="part-6" className="mb-[60px] w-2/3 rounded-md flex flex-col items-cente">
      <ul className="flex flex-col space-y-4 px-6 py-4 w-full">
        {
          coustmer && coustmer.map((item) => {
            const { id, name, picture } = item
            return (
              <li key={id} className="w-full h-48 flex items-center flex-col justify-center rounded-md bg-slate-100 py-4">
                <img src={picture} className="w-32 h-32 mb-2" />
                <h3>{name}</h3>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

const ImageBackground = () => {
  return (
    <div className="flex flex-col font-bold justify-center gap-y-6 items-center solution-image text-slate-100 w-screen h-[1000px]">
      <p className="text-[100px]">墨圆方</p>
      <p className="text-[66px]">善制造之事、利智能之器</p>
      <div className="flex space-x-12 mt-28 px-12">
        <div className="flex flex-col items-center w-[400px] gap-4">
          <h2 className="font-semibold text-[44px]">愿景（Vision）</h2>
          <p className="text-3xl leading-10">为制造企业赋新、赋能的组织</p>
        </div>
        <div className="flex flex-col items-center w-[400px] gap-4">
          <h2 className="font-semibold text-[44px]">使命（Mission）</h2>
          <p className="text-3xl leading-10">创造工程逻辑和智能化融合的场景</p>
        </div>
        <div className="flex flex-col items-center w-[400px] gap-4">
          <h2 className="font-semibold text-[44px]">价值观（Values）</h2>
          <p className="text-3xl leading-10">以不争、不二、不同、不懈成就价值</p>
        </div>
        <div className="flex flex-col items-center w-[400px] gap-4">
          <h2 className="font-semibold text-[44px]">思略（Tactics）</h2>
          <p className="text-3xl leading-10">超维定位、经略生态、主动进化、举纲张目、锤炼神器</p>
        </div>
      </div>
    </div>
  )
}


const Ours = () => {
  const coustmer = useFetch('http://1.94.62.64:9090/myf/aboutus/behalfCustomers')
  const d = useFetch('http://1.94.62.64:9090/myf/aboutus/importEvents')

  const tabs = [{
    label: <span className="text-3xl font-semibold">公司概况</span>,
    element: (
      <div className="flex flex-col items-center">
        <p className="mt-2 text-2xl leading-10">上海墨圆方信息科技有限公司成立于2022年12月，为学生创业和科技型公司，创业学生占股为40%。注册在
          <a
            target="_blank"
            href="https://map.baidu.com/poi/%E7%8E%AF%E4%B8%8A%E5%A4%A7%E7%A7%91%E6%8A%80%E5%9B%AD%E9%9B%B6%E5%8F%B7%E5%9F%BA%E5%9C%B0/@13514724.194998443,3653493.2766355514,13z?uid=f6b8b14f2046ad4603ff2d9a&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl">
            <strong className="text-2xl text-red-600 font-bold">上海环上大科技园</strong>
          </a>
          公司致力于制造业工业软件的研发，本项目为公司主营业务的重要组成部分。2023年7月通过ISO 9001质量体系认证
        </p>
        <img src="http://1.94.62.64:9090/myf/photos/s9000.png" className="w-72" />
      </div>
    )
  }, {
    label: <span className="text-3xl font-semibold">公司技术团队</span>,
    element: (
      <p className="mt-2 text-2xl leading-10">目前公司核心技术成员包括博士一名、硕士4名。皆毕业于上海大学机电工程与自动化学院尺寸工程团队。该团队在产品几何质量方面有30余年的技术积累，曾主持和参与了多项国家科研攻关项目、近30余项几何技术规范领域的国家标准。近几年来发表尺寸工程领域学术论文10余篇，获5项发明专利授权。公司成立以来，已申请发明专利3项，申报软件著作权3项、参与国家标准制修订10余项。</p>
    )
  }, {
    label: <span className="text-3xl font-semibold">公司技术顾问</span>,
    element: (
      <div className=" p-8 flex justify-center">
        <img
          className="w-80 mr-6"
          draggable={false}
          src="http://1.94.62.64:9090/myf/photos/liming_head.png"
          alt="公司技术顾问"
        />
        <div className="pl-4">
          <div className="font-semibold flex flex-col gap-y-2">
            <div className="text-sky-500 text-2xl">李明</div>
            <div className="text-slate-700 text-xl">教授/博导 公司技术顾问</div>
          </div>
          <p className="text-lg font-medium pr-20">
            &gt; 上海大学机电工程与自动化学院尺寸工程团队负责人,为国内知名的智能制造、几何质量和标准化专家。
            <br />
            &gt; 曾任上海大学机械自动化工程系主任、上海大学工程技术训练中心主任。
          </p>
          <p className="font-semibold my-2 text-lg">&gt; 目前担任的学术职务包括：</p>
          <p className="pl-2 text-md">
            1. 中国计量检测学会几何量技术委员会顾问
            <br />
            2. 全国产品几何技术规范标准化技术委员会委员(SAC/TC240 , ISO/TC213)
            <br />
            3. 全国航空器标准化技术委员会航空器数据定义与管理分技术委员会委员（SAC/TC 435 SC2）
            <br />
            4. 全国减速器标准化技术委员会委员（SAC/TC 357）
            <br />
            5. 机械工业工艺工装标准化技术委员会委员（CMIF /TC13）
            <br />
            6. 中国汽车工程学会尺寸工程专业委员会副主任
            <br />
            7. 上海机械工程学会先进制造专业技术委员会主任委员
            <br />
            8. 中国尺寸工程联盟召集人
            <br />
            9. 第1届科创板股票上市委员会委员
          </p>
        </div>
      </div>
    )
  }]

  return (
    <div className="flex flex-col justify-center items-center bg-slate-100">
      <ImageBackground />
      <div className='w-[1000px] h-[400px] mt-24 mb-3'>
        <div className="flex justify-center items-center">
          <Tabs
            centered
            size="large"
            items={tabs.map((item, idx) => {
              const { label, element } = item
              return {
                label,
                key: idx,
                children: element
              }
            })}
          />
        </div>
      </div>
      <div className="h-full flex py-44 flex-col items-center bg-slate-100">
        <BigEvent d={d} />
        <hr className="my-12" />
        {
          (coustmer && coustmer.length !== 0)
          &&
          <>
            <h2 className="text-2xl my-10 font-bold">代表客户</h2>
            <Customer coustmer={coustmer} />
          </>
        }
      </div>
    </div>
  )
};

export default Ours;
